import SelectedEventsAPI from "./selected";
import UserMediaEventsAPI from "./user-media";
import EventStatsAPI from "./stats";
import type { IRequestOptionsEvents, IResponseEvent } from "./event.types";
import Event from "./event.model";
import useRequest from "~/hooks/use-request";

const EventsAPI = {
  selected: SelectedEventsAPI,
  userMedia: UserMediaEventsAPI,
  stats: EventStatsAPI,

  load(options: IRequestOptionsEvents): Promise<IPaginatedResponse<IModelEvent>> {
    const { request } = useRequest();
    const params = Event.params(options);
    const searchType = options.contentType === "highlight" ? "vod" : "event";

    return request
      .post<IPaginatedResponse<IResponseEvent>>(`/api/${searchType}/list`, { body: params, setAuthorization: true })
      .then(Event.formatPaginated);
  },

  loadById(id: string, type?: TEventType, idType?: TIdType): Promise<IModelEvent> {
    const { request } = useRequest();
    const searchType = (type === "highlight" || type === "user_clip" || type === "user_highlight") ? "vod" : "event";
    return request
      .get<IContentResponse<IResponseEvent>>(`/api/${searchType}/get_by_id/id/${id}`, { setAuthorization: true, query: { idType } })
      .then(response => Event.format(response.content));
  },

  loadRelatedVideos(options: { id: string; excludeVideo: boolean }): Promise<IPaginatedResponse<IModelEvent>> {
    const { request } = useRequest();
    const excludedVideoId = options.excludeVideo ? options.id : undefined;

    return request
      .get<IContentResponse<IResponseEvent>>(`/api/vod/get_related_videos?id=${options.id}`, { setAuthorization: true })
      .then(response => Event.mergeSuggested(response, excludedVideoId));
  },
};

export default EventsAPI;
